// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publish-icon {
    color: #2196f3;
}

.unpublish-icon {
    color: darkgrey;
}

.p-r1 {
    padding-right: 10px;
}

.New-page {
    position: absolute;
    z-index: 999;
    top: 70px;
}

.kt-widget5 .kt-widget5__item .kt-widget5__content:last-child {
    flex-grow: 0;
}

.border-b-3 {
    border-bottom: 3px solid #e2e5ec;
}

.bg-white {
    background: #fff;
}

.list-group-item {
    padding: .75rem 0rem;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}

.p-25 {
    padding: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/app/views/page-templates/page-templates.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".publish-icon {\r\n    color: #2196f3;\r\n}\r\n\r\n.unpublish-icon {\r\n    color: darkgrey;\r\n}\r\n\r\n.p-r1 {\r\n    padding-right: 10px;\r\n}\r\n\r\n.New-page {\r\n    position: absolute;\r\n    z-index: 999;\r\n    top: 70px;\r\n}\r\n\r\n.kt-widget5 .kt-widget5__item .kt-widget5__content:last-child {\r\n    flex-grow: 0;\r\n}\r\n\r\n.border-b-3 {\r\n    border-bottom: 3px solid #e2e5ec;\r\n}\r\n\r\n.bg-white {\r\n    background: #fff;\r\n}\r\n\r\n.list-group-item {\r\n    padding: .75rem 0rem;\r\n    border-top: 0;\r\n    border-left: 0;\r\n    border-right: 0;\r\n}\r\n\r\n.p-25 {\r\n    padding: 25px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
